import { createSlice } from '@reduxjs/toolkit';
import { getProducts, getTotalProducts, loadMoreProducts } from './thunks';
import { isWeb } from '~global/screens';
import { sortProductsByPrice } from '~global/utils/product';

const bundlePacksSlice = createSlice({
  name: 'bundlePacks',
  initialState: {
    products: [],
    totalProducts: '...',
    status: {
      products: 'idle',
      totalProducts: 'idle',
      loadMoreProducts: 'idle',
    },
  },
  reducers: {
    setState(state, { value, name }) {
      state[name] = value;
    },
    setStatusApi(state, { value, name }) {
      state.status[name] = value;
    },
    resetBundlePacksState(state) {
      state.products = [];
      state.totalProducts = '...';
      state.status = {
        products: 'idle',
        totalProducts: 'idle',
        loadMoreProducts: 'idle',
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.status.products = 'loading';
      })
      .addCase(getProducts.rejected, (state) => {
        state.status.products = 'error';
      })
      .addCase(getProducts.fulfilled, (state, { payload, meta }) => {
        let products = payload.data;

        if (meta.arg && meta.arg.sort) {
          products = sortProductsByPrice(products, meta.arg.sort);
        }

        state.products = products;
        state.status.products = 'succeeded';
      })
      .addCase(getTotalProducts.pending, (state) => {
        state.status.totalProducts = 'loading';
      })
      .addCase(getTotalProducts.rejected, (state) => {
        state.status.totalProducts = 'error';
      })
      .addCase(getTotalProducts.fulfilled, (state, { payload }) => {
        state.totalProducts = payload.data;
        state.status.totalProducts = 'succeeded';
      })
      .addCase(loadMoreProducts.pending, (state) => {
        state.status.loadMoreProducts = 'loading';
      })
      .addCase(loadMoreProducts.rejected, (state) => {
        state.status.loadMoreProducts = 'error';
      })
      .addCase(loadMoreProducts.fulfilled, (state, { payload, meta }) => {
        let combinedProducts;

        if (isWeb) {
          combinedProducts = payload.data;
        } else {
          const existingIds = state.products.map((product) => product.id);
          const newUniqueProducts = payload.data.filter(
            (product) => !existingIds.includes(product.id),
          );
          combinedProducts = [...state.products, ...newUniqueProducts];
        }

        if (meta.arg && meta.arg.sort) {
          combinedProducts = sortProductsByPrice(
            combinedProducts,
            meta.arg.sort,
          );
        }

        state.products = combinedProducts;
        state.status.loadMoreProducts = 'succeeded';
      });
  },
});

export default bundlePacksSlice.reducer;
